module.exports = __webpack_public_path__ + "media/images/top/common/img_voice_result03-e7ad17bddabb3cd7da20d50902b086c0.png";